'use strict';

require('./progress.scss');

$$('.ll-progress').each(function () {
	var $el = $$(this);

	console.log($el);
});


//////////////////
// WEBPACK FOOTER
// ./src/components/progress/progress.js
// module id = 111
// module chunks = 0